import { render, staticRenderFns } from "./igt-key-items.vue?vue&type=template&id=0c951a6e&scoped=true&"
import script from "./igt-key-items.vue?vue&type=script&lang=js&"
export * from "./igt-key-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c951a6e",
  null
  
)

export default component.exports